module.exports = __webpack_public_path__ + "static/media/optout_1.2ee191e1.svg";